const columns = [
  { name: 'title', title: 'Bezeichnung' },
  { name: 'booking_account_nr', title: 'Konten Nr.' },
];

export default columns;
